import { render, staticRenderFns } from "./AppEditor.vue?vue&type=template&id=24528da6"
import script from "./AppEditor.vue?vue&type=script&lang=js"
export * from "./AppEditor.vue?vue&type=script&lang=js"
import style0 from "./AppEditor.vue?vue&type=style&index=0&id=24528da6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports